import React from "react";
import styled from "styled-components";
import { colors } from "styles/color-tokens";
import ShareIcon from "assets/icons/share.svg";
import { ContactSupport, LinkText } from "./common-components";
import { UpsellFeatureType } from "./types";
import { getDisplayFeatureName } from "./plan-utils";
import { HubSpotHelpChatTopic } from "libs/support/open-support-chat";

export const UpsellFooter = ({
  hideViewAllPlan,
  infoText = "For help, ",
  textStyle,
  feature,
  supportText,
  helpChatTopic = "upsell",
}: {
  hideViewAllPlan?: boolean;
  infoText?: string;
  textStyle?: React.CSSProperties;
  feature: UpsellFeatureType;
  supportText?: string;
  helpChatTopic?: HubSpotHelpChatTopic;
}) => {
  if (!supportText) {
    supportText =
      feature === "unknown"
        ? ""
        : `Hey, I'm interested in learning more about upgrading my plan to access ${getDisplayFeatureName(
            feature
          )}. Can you help me?`;
  }

  return (
    <FooterContainer>
      <FooterLeftSection>
        <QuestionText style={textStyle}>{infoText}</QuestionText>{" "}
        <ContactSupport
          supportChatText={supportText}
          helpChatTopic={helpChatTopic}
        />
      </FooterLeftSection>
      {!hideViewAllPlan && (
        <FooterRightSection>
          <LinkText href="https://skedsocial.com/pricing" target="_blank">
            View all plans <ShareIcon />
          </LinkText>
        </FooterRightSection>
      )}
    </FooterContainer>
  );
};

const FooterContainer = styled.div`
  display: flex;
`;
const FooterLeftSection = styled.div``;
const FooterRightSection = styled.div`
  flex: 1;
  text-align: right;
`;

const QuestionText = styled.span`
  //styleName: Web App/Paragraph 2 Regular;
  font-family: Inter, Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${colors.neutral500};
`;
